import {
    GET_LEADOM_CONFIG_REQUEST,
    GET_LEADOM_CONFIG_REQUEST_SUCCESS,
    GET_LEADOM_CONFIG_REQUEST_FAILURE,
    CHANGE_LEADOM_CONFIG_REQUEST,
    CHANGE_LEADOM_CONFIG_REQUEST_SUCCESS,
    CHANGE_LEADOM_CONFIG_REQUEST_FAILURE,
} from '../constants/leadom_config.constants';

const initialState = {
    loading: false,
    config: null,
    config_id: null,
    error: null,
};

export const Lead_o_matic_update = (state = initialState, action) => {
    switch (action.type) {
    case GET_LEADOM_CONFIG_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case CHANGE_LEADOM_CONFIG_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_LEADOM_CONFIG_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            config: action.payload,
            config_id: action.payload._id,
        };
    case CHANGE_LEADOM_CONFIG_REQUEST_SUCCESS:
        return {
            ...state,
            loading: true,
            config: action.payload,
        };
    case GET_LEADOM_CONFIG_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
            loading: false,
        };
    case CHANGE_LEADOM_CONFIG_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
            loading: false,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/redux/reducers/leadomatic_config.reducers.js